import { Api } from '../api';

export type GetKeyAccountsResponse = {
  token: string;
  phone: string | null;
  email: string | null;
};

export const changePassword = async (
  currentPassword: string,
  newPassword: string,
): Promise<any> => {
  const api = new Api();

  try {
    const response = await api.request('POST', 'identity/my-profile/change-password', true, { 
      currentPassword,
      newPassword
    });
    return response;
  } catch (error) {
    throw error;
  }
};